import type { Dictionnaire } from '../type';

export const sorties: Dictionnaire['sorties'] = {
  erreurs: {
    introuvable: 'Evento no encontrado',
    titre: 'Ponle un título a tu evento',
    lieu: 'Indica un punto de encuentro',
    adresse: 'Elige una dirección de la lista propuesta',
    horsZone: 'Elige una dirección en el país de este spot.',
    lien: 'Este enlace no lleva a ninguna parte: revísalo o deja el campo vacío',
    dateInvalide: 'Elige una fecha válida',
    datePassee: 'La fecha ya ha pasado',
    heureDebut: 'Indica la hora de inicio',
    heureFin: 'Indica la hora de fin',
    finDifferente: 'La hora de fin tiene que ser distinta de la de inicio',
    passe: {
      inscrire: 'ya no se puede apuntar nadie',
      valider: 'ya no se pueden validar solicitudes',
      modifier: 'ya no se puede modificar',
      figee: 'su lista de participantes está cerrada',
      retirer: 'ya no puedes salir de él',
      reprendre: 'ya no hay nada que traspasar',
      supprimer: 'ya no se puede borrar',
    },
    annuleFaute: 'Este evento se ha cancelado por falta de participantes',
    complet: 'Todas las plazas están ocupadas, libera una antes de aceptar',
    pasInscrite: 'Esta persona no está apuntada a este evento',
    feuillePasFinie: 'La hoja de asistencia se revisa cuando el evento ha terminado',
    feuilleValidee: 'Esta hoja de asistencia ya está validada',
    note: 'Una nota va de 1 a 5',
    finApresDebut: 'La hora de fin tiene que ser posterior a la de inicio',
    tropTard: 'Este evento empieza en menos de diez horas: ya no se puede modificar',
    creneauPasse: 'Esta franja horaria ya ha pasado',
    organisateurReste: 'Organizas este evento, no puedes quitarte',
    sansGroupe: 'Este evento no tiene grupo',
    seulOrganisateur: 'Solo el organizador gestiona a los participantes',
    organisateurPart: 'Organizas este evento: traspásalo o bórralo',
    autreQuelquun: 'Elige a otra persona para que se encargue del evento',
    neParticipePas: 'Esta persona no participa en el evento',
    nombreParticipants: (min: number, max: number) =>
      `El número de participantes tiene que estar entre ${min} y ${max}`,
    suspendu: (jusqua: number) =>
      `Has faltado a dos eventos sin avisar: podrás volver a apuntarte el ${new Date(jusqua).toLocaleDateString('es-ES')}`,
    estPasse: (raison: string) => `Este evento ya ha pasado: ${raison}`,
    creneauPris: (titre: string) => `Ya tienes algo a esa hora: «${titre}»`,
  },
  carte: {
    inscrit: 'Apuntado',
    enAttente: 'Pendiente',
    complet: 'Completo',
    note: (note: string) => `Organizador valorado con ${note} sobre 5`,
    participants: (n: number, max: number) => `${n}/${max} participantes`,
  },
  commun: {
    autresActions: 'Más acciones',
    lieu: 'Lugar',
    date: 'Fecha',
    participants: 'Participantes',
    monBillet: 'Mi entrada',
    enLigne: 'En línea',
    masquerQ: '¿Ocultar este evento?',
    masquer: 'Ocultar este evento',
    actionImpossible: 'No se puede hacer ahora mismo.',
  },
  fiche: {
    noteNonEnvoyee: 'No se ha podido enviar esta valoración.',
    groupeImpossible: 'No se ha podido abrir el grupo',
    ecrireImpossible: 'No puedes escribirle ahora mismo.',
    desinscrireQ: '¿Desapuntarte de este evento?',
    titre: 'Evento',
    adresseComplete: 'Dirección completa',
    partager: 'Compartir el evento',
    retirerMasques: 'Quitar de ocultos',
    presenceEnregistree: 'Tu asistencia se ha registrado.',
    montreLeCarre: 'Enseña este código al organizador al llegar: confirma tu asistencia.',
    passe: 'Este evento ya ha pasado',
    gerer: 'Gestionar mi evento',
    rejoindreGroupe: 'Unirme al grupo',
    groupe: 'El grupo de la salida',
    monAgenda: 'Mi agenda',
    presenceConfirmee: 'Asistencia confirmada',
    horaire: 'Horario',
    places: 'Plazas',
    lien: 'Enlace',
    lienApresInscription: 'Tras inscribirte',
    rejoindre: (hote: string) => `Unirse en ${hote}`,
    noteOrganisateur: 'Valora al organizador',
    commentCaSEstPasse: '¿Qué tal fue este evento?',
    noteSurCinq: 'Nota sobre 5',
    langues: 'Idiomas',
    description: 'Descripción',
    organise: 'Organiza',
    prevenir: 'Avisa al organizador si ya no puedes ir. Dos ausencias cierran la inscripción a eventos durante una semana.',
    autresApresAcceptation: 'Los demás participantes aparecen cuando se acepta tu participación.',
    annulerDemande: 'Cancelar mi solicitud',
    meDesinscrire: 'Desapuntarme',
    listeAttente: 'Unirme a la lista de espera',
    demanderAParticiper: 'Pedir participar',
    participer: 'Participar',
    gererDemandes: (n: number) => `Gestionar · ${n} solicitud${n === 1 ? '' : 'es'}`,
    suspendu: (jusqua: number) =>
      `Dos ausencias: podrás apuntarte a partir del ${new Date(jusqua).toLocaleDateString('es-ES')}`,
    organisePar: (nom: string) => `Organizado por ${nom}`,
    ecrireA: (nom: string) => `Escribir a ${nom}`,
    noteAide: (nom: string) => `Valora a ${nom}. Una valoración no se puede deshacer.`,
    surCinq: (n: number) => `${n} sobre 5`,
    donnerQ: (n: number, nom: string) =>
      `¿Dar ${n} estrella${n === 1 ? '' : 's'} a ${nom}? Esta valoración es definitiva.`,
    demandesEnAttente: (n: number) =>
      `${n} solicitud${n === 1 ? '' : 'es'} esperando tu respuesta.`,
  },
  gestion: {
    groupeImpossible: 'No se ha podido crear el grupo.',
    passationImpossible: 'No se puede traspasar ahora mismo.',
    feuilleTousLa: 'Hoja validada. Vinieron todos.',
    validationImpossible: 'No se puede validar ahora mismo.',
    scan: {
      pasSirocco: 'Este código no es de Sirocco.',
      autreSortie: 'Esta entrada es de otro evento.',
      pasInscrite: 'Esta persona no está apuntada aquí.',
      impossible: 'No se ha podido registrar.',
      dejaPresent: (nom: string) => `${nom} ya está marcado como presente.`,
      present: (nom: string) => `${nom} · presente`,
    },
    suppressionImpossible: 'No se puede borrar ahora mismo.',
    quitter: 'Salir del evento',
    supprimerQ: '¿Borrar el evento?',
    supprimer: 'Borrar el evento',
    aQui: '¿A quién le dejas la organización?',
    modifier: 'Modificar el evento',
    scanner: 'Escanear las entradas',
    reserve: 'Solo para el organizador',
    reserveAide: 'Solo la persona que organiza este evento puede gestionar a sus participantes.',
    tropTard: 'Demasiado tarde para modificarlo: el evento empieza en menos de diez horas.',
    scannerUn: 'Escanear una entrada',
    ouvrirGroupe: 'Abrir el grupo',
    creerGroupe: 'Crear el grupo',
    personneAReunir: 'Nadie a quien reunir',
    demandes: 'Solicitudes',
    feuilleAVerifier: 'Hoja de asistencia por revisar',
    feuilleAide: 'Abre los participantes, marca a quienes vinieron y valida. Los demás contarán como ausentes; dos ausencias cierran la inscripción de un miembro durante una semana.',
    validerTousQ: '¿Validar la hoja? Todos están marcados como presentes.',
    valider: 'Validar la hoja',
    modificationImpossible: 'No se ha podido modificar.',
    champs: {
      titre: 'Título',
      debut: 'Inicio',
      fin: 'Fin',
    },
    placesGardees: 'Los participantes ya apuntados mantienen su plaza. El número de plazas no se puede cambiar.',
    enregistrer: 'Guardar',
    ouvertureCamera: 'Abriendo la cámara…',
    feuilleAbsents: (n: number) =>
      `Hoja validada. ${n} ausencia${n === 1 ? '' : 's'} registrada${n === 1 ? '' : 's'}.`,
    laisserQ: (nom: string) => `¿Dejar la organización a ${nom}?`,
    valideeLe: (date: string) => `Hoja validada el ${date}`,
    validerQ: (n: number) =>
      `¿Validar la hoja? ${n} persona${n === 1 ? ' contará como ausente' : 's contarán como ausentes'}.`,
  },
  categories: {
    sport: 'Deporte',
    culture: 'Cultura',
    pro: 'Pro',
    food: 'Comida',
    asso: 'Club',
    etudes: 'Estudios',
    jeux: 'Juegos',
  },
  reserve: {
    titre: 'Solo para el organizador',
  },
  creation: {
    impossible: 'No se ha podido publicar',
    titreSortie: 'Proponer una salida',
    titreEvenement: 'Crear un evento',
    publierSortie: 'Publicar la salida',
    publierEvenement: 'Publicar el evento',
    type: 'Tipo de salida',
    evenement: 'Evento',
    spontanee: 'Espontánea',
    enLigne: 'En línea',
    affiche: 'Cartel (opcional)',
    choisirAffiche: 'Elegir un cartel',
    retirerAffiche: 'Quitar el cartel',
    quoi: '¿Qué?',
    titre: 'Título',
    exempleSortie: 'Café en el Clock',
    exempleEvenement: 'Fútbol 5',
    categorie: 'Categoría',
    horaires: 'Horario',
    heureDebut: 'Hora de inicio',
    heureFin: 'Hora de fin',
    ouSurLeCampus: '¿Dónde en el campus? Anfiteatro, aula, campo…',
    campusAile: (aile: string) => (aile.length <= 2 ? `Ala ${aile}` : aile),
    campusEtage: (n: number) => (n === 0 ? 'planta baja' : `${n}.ª planta`),
    chercheAdresse: 'Busca una dirección',
    lien: 'Enlace para conectarse (opcional)',
    lienExemple: 'https://zoom.us/j/…',
    lienAide: 'Una videollamada, un servidor de Discord… Solo lo verán en la ficha quienes se inscriban.',
    placeSurLePlan: 'Situado en el plano, pulsa para moverlo',
    placerSurLePlanBouton: 'Situar en el plano del campus',
    annuaireMuet: 'El buscador de direcciones no responde. Vuelve a intentarlo en un momento.',
    aucuneAdresse: 'No se ha encontrado ninguna dirección. Indica la calle o el nombre del lugar.',
    nombreParticipants: 'Número de participantes',
    maximum: 'Máximo',
    retirerPlace: 'Quitar una plaza',
    ajouterPlace: 'Añadir una plaza',
    seConfirme: 'Se confirma a partir de',
    abaisserSeuil: 'Bajar el mínimo',
    aucun: 'Ninguno',
    releverSeuil: 'Subir el mínimo',
    description: 'Descripción',
    descriptionExemple: 'Lo que hay que saber: nivel, material, punto de encuentro...',
    validation: 'Validación de participantes',
    langues: 'Idioma hablado',
    languesTitre: 'Idiomas hablados',
    languesMax: 'Tres idiomas como máximo.',
    languesChercher: 'Buscar un idioma',
    languesAucune: 'Ningún idioma coincide.',
    languesTermine: 'Listo',
    languesNoms: { ary: 'Árabe marroquí', zgh: 'Amazig' },
  },
  filtres: {
    titre: 'Filtros de eventos',
    quand: 'Cuándo',
    du: 'Del',
    aPartirDu: 'A partir del',
    au: 'al',
    jusquAu: 'Hasta el',
    distance: 'Distancia',
    rayon: 'Radio a mi alrededor',
    sansDistance: 'Sin distancia',
    sansPosition: 'No se encuentra tu posición. El filtro de distancia necesita tu ubicación.',
    nature: 'Tipo',
    spontanees: 'Salidas espontáneas',
    enLigne: 'En línea',
    categories: 'Categorías',
    langues: 'Idiomas',
    toutesLangues: 'Todos los idiomas',
    appliquer: 'Aplicar los filtros',
    effacer: 'Borrar',
    kilometres: (n: number) => `${n} kilómetro${n === 1 ? '' : 's'}`,
  },
  liste: {
    rechercher: 'Buscar...',
    carte: 'Mapa de eventos',
    agenda: 'Mi agenda',
    creer: 'Crear un evento',
    masques: 'Eventos ocultos',
    filtreActif: 'Filtrar · hay un filtro activo',
    filtrer: 'Filtrar',
    unSansAdresse: '1 salida sin dirección precisa no se cuenta en este radio.',
    aucun: 'Ningún evento',
    elargir: 'Prueba a ampliar tus categorías.',
    personne: 'Todavía nadie ha propuesto una salida aquí.',
    proposer: 'Proponer una salida',
    pourToi: 'Para ti',
    toutes: 'Todas las salidas',
    sansAdresse: (n: number) => `${n} salidas sin dirección precisa no se cuentan en este radio.`,
    rienAMoinsDe: (km: number) => `Nada a menos de ${km} km de ti. Prueba con un radio mayor.`,
  },
  agenda: {
    onglets: {
      aVenir: 'Próximos',
      jOrganise: 'Organizo',
    },
    titre: 'Mi agenda',
    semaine: 'ESTA SEMANA',
    plusTard: 'MÁS ADELANTE',
    rien: 'Nada que mostrar aquí',
    rienAide: 'Apúntate a una salida o propón la tuya: aparecerá aquí.',
    rienOrganise: 'Los eventos que organizas aparecerán aquí.',
    voir: 'Ver los eventos',
    proposer: 'Proponer una salida',
  },
  participants: {
    titre: 'Participantes',
    reserveAide: 'Solo la persona que organiza este evento puede ver esta lista.',
    chercher: 'Buscar un participante',
    personne: 'Nadie con ese nombre en este evento.',
    present: 'Presente',
    organise: 'Organiza',
    absent: 'Ausente',
    retirerQ: (nom: string) => `¿Quitar a ${nom} del evento?`,
    retirerPresence: (nom: string) => `Quitar la asistencia de ${nom}`,
    estLa: (nom: string) => `${nom} está aquí`,
  },
  demandes: {
    titre: 'Solicitudes',
    reserveAide: 'Solo la persona que organiza este evento puede gestionar sus solicitudes.',
    chercher: 'Buscar una solicitud',
    personne: 'Nadie con ese nombre en las solicitudes.',
    aucune: 'Ninguna solicitud',
    aucuneAide: 'Las solicitudes de participación llegarán aquí.',
    ouvert: 'Este evento acepta a todo el mundo directamente, mientras queden plazas.',
    rang: (rang: number) => `${rang}.º de la lista`,
    accepter: (nom: string) => `Aceptar a ${nom}`,
    refuser: (nom: string) => `Rechazar a ${nom}`,
  },
  miennes: {
    onglets: {
      inscrit: 'Apuntado',
      organise: 'Organizados',
      passes: 'Pasados',
    },
    vides: {
      inscrit: 'Tus inscripciones aparecerán aquí.',
      organise: 'Los eventos que organizas aparecerán aquí.',
      passes: 'Los eventos en los que se confirmó tu asistencia aparecerán aquí.',
    },
    titre: 'Mis eventos y salidas',
    uneFeuille: 'Una hoja de asistencia por revisar',
    rien: 'Nada que mostrar aquí',
    feuilles: (n: number) => `${n} hojas de asistencia por revisar`,
  },
  masques: {
    titre: 'Eventos ocultos',
    aucun: 'Ningún evento oculto',
    aucunAide: 'Los que ocultas desde su ficha acaban aquí.',
    remettre: 'Abre un evento para volver a ponerlo en tus listas.',
  },
};
